import { Component, computed, input } from '@angular/core';
import { CardComponent } from '@sportello-balneari/shared-components';
import { ProgressBarModule } from 'primeng/progressbar';
import { TenderFormAnswerEvaluationProgress } from '../../../../../api/interfaces';
import {
  EVALUATION_STATUS_LABELS,
  evaluationStatusClass,
} from '../../../../../services/compiling/evaluation-status-labels';

@Component({
  selector: 'lib-result-progress-card',
  standalone: true,
  imports: [CardComponent, ProgressBarModule],
  templateUrl: './progress-card.component.html',
})
export class ResultProgressCardComponent {
  progress = input<TenderFormAnswerEvaluationProgress | null>(null);

  readonly statusLabel = computed(() => {
    const status = this.progress()?.status;
    return status ? EVALUATION_STATUS_LABELS[status] : '';
  });

  readonly statusClass = computed(() => evaluationStatusClass(this.progress()?.status));
}
